export const traveler_form = {
    booking_select_traveler_information_form_basic_info_first_name: {
        category: "Traveler Information",
        action: "User enters first name",
        label: "traveler-info-basic-first-name-click",
    },
    booking_select_traveler_information_form_basic_info_middle_name: {
        category: "Traveler Information",
        action: "User enters middle name",
        label: "traveler-info-basic-middle-name-click",
    },
    booking_select_traveler_information_form_basic_info_last_name: {
        category: "Traveler Information",
        action: "User enters last name",
        label: "traveler-info-basic-last-name-click",
    },
    booking_select_traveler_information_form_basic_info_date_of_birth_month: {
        category: "Traveler Information",
        action: "User selects DOB month",
        label: "traveler-info-basic-dob-mth-open-click",
    },
    traveler_info_basic_dob_mth_close_click: {
        category: "Traveler Information",
        action: "User closes date of birth month selector",
        label: "traveler-info-basic-dob-mth-close-click",
    },
    traveler_info_basic_dob_mth_option_click: {
        category: "Traveler Information",
        action: "User selects date of birth month option",
        label: "traveler-info-basic-dob-mth-option-click",
    },

    booking_select_traveler_information_form_basic_info_date_of_birth_day: {
        category: "Traveler Information",
        action: "User selects DOB day",
        label: "traveler-info-basic-dob-day-click",
    },
    booking_select_traveler_information_form_basic_info_date_of_birth_year: {
        category: "Traveler Information",
        action: "User selects DOB year",
        label: "traveler-info-basic-dob-year-click",
    },
    booking_select_traveler_information_form_basic_info_gender: {
        category: "Traveler Information",
        action: "User selects gender",
        label: "traveler-info-basic-gender-open-click",
    },
    traveler_info_basic_gender_close_click: {
        category: "Traveler Information",
        action: "User closes gender selector",
        label: "traveler-info-basic-gender-close-click",
    },
    traveler_info_basic_gender_option_click: {
        category: "Traveler Information",
        action: "User selects a gender option",
        label: "traveler-info-basic-gender-option-click",
    },

    booking_select_traveler_information_contact_info_email: {
        category: "Traveler Information",
        action: "User enters email",
        label: "traveler-info-cntct-email-input-click",
    },
    booking_select_traveler_information_contact_info_country_code: {
        category: "Traveler Information",
        action: "User selects country code",
        label: "traveler-info-cntct-ctry-cd-open-click",
    },
    traveler_info_cntct_ctry_cd_close_click: {
        category: "Traveler Information",
        action: "User closes contact country code selector",
        label: "traveler-info-cntct-ctry-cd-close-click",
    },
    traveler_info_cntct_ctry_cd_option_click: {
        category: "Traveler Information",
        action: "User selects contact country code option",
        label: "traveler-info-cntct-ctry-cd-option-click",
    },

    booking_select_traveler_information_contact_info_phone_number: {
        category: "Traveler Information",
        action: "User enters phone number",
        label: "traveler-info-cntct-phone-number-click",
    },

    booking_select_traveler_information_passport_issuing_country: {
        category: "Traveler Information",
        action: "User selects passport issuing country",
        label: "traveler-info-pport-ctry-open-click",
    },
    traveler_info_pport_ctry_option_click: {
        category: "Traveler Information",
        action: "User selects passport issuing country option",
        label: "traveler-info-pport-ctry-option-click",
    },
    traveler_info_pport_ctry_close_click: {
        category: "Traveler Information",
        action: "User closes passport issuing country selector",
        label: "traveler-info-pport-ctry-close-click",
    },

    booking_select_traveler_information_passport_passport_number: {
        category: "Traveler Information",
        action: "User enters passport number",
        label: "traveler-info-pport-number-click",
    },
    booking_select_traveler_information_passport_nationality: {
        category: "Traveler Information",
        action: "User selects nationality",
        label: "traveler-info-pport-natn-open-click",
    },
    traveler_info_pport_natn_close_click: {
        category: "Traveler Information",
        action: "User closes passport nationality selector",
        label: "traveler-info-pport-natn-close-click",
    },
    traveler_info_pport_natn_option_click: {
        category: "Traveler Information",
        action: "User selects passport nationality option",
        label: "traveler-info-pport-natn-option-click",
    },

    booking_select_traveler_information_passport_issue_date_month: {
        category: "Traveler Information",
        action: "User selects passport issue month",
        label: "traveler-info-pport-iss-mth-open-click",
    },
    traveler_info_pport_iss_mth_close_click: {
        category: "Traveler Information",
        action: "User closes passport issue month selector",
        label: "traveler-info-pport-iss-mth-close-click",
    },
    traveler_info_pport_iss_mth_option_click: {
        category: "Traveler Information",
        action: "User selects passport issue month option",
        label: "traveler-info-pport-iss-mth-option-click",
    },

    booking_select_traveler_information_passport_issue_date_day: {
        category: "Traveler Information",
        action: "User selects passport issue day",
        label: "traveler-info-pport-iss-day-click",
    },
    booking_select_traveler_information_passport_issue_date_year: {
        category: "Traveler Information",
        action: "User selects passport issue year",
        label: "traveler-info-pport-iss-year-click",
    },
    booking_select_traveler_information_passport_expiration_date_month: {
        category: "Traveler Information",
        action: "User selects passport expiration month",
        label: "traveler-info-pport-exp-mth-open-click",
    },
    traveler_info_pport_exp_mth_close_click: {
        category: "Traveler Information",
        action: "User closes passport expiry month selector",
        label: "traveler-info-pport-exp-mth-close-click",
    },
    traveler_info_pport_exp_mth_option_click: {
        category: "Traveler Information",
        action: "User selects passport expiry month option",
        label: "traveler-info-pport-exp-mth-option-click",
    },
    booking_select_traveler_information_passport_expiration_date_day: {
        category: "Traveler Information",
        action: "User selects passport expiration day",
        label: "traveler-info-pport-exp-day-click",
    },
    booking_select_traveler_information_passport_expiration_date_year: {
        category: "Traveler Information",
        action: "User selects passport expiration year",
        label: "traveler-info-pport-exp-year-click",
    },

    booking_select_traveler_information_additional_info_plus_click: {
        category: "Traveler Information",
        action: "User opens additional info section",
        label: "traveler-info-add-info-open-click",
    },
    booking_select_traveler_information_additional_info_close_click: {
        category: "Traveler Information",
        action: "User closes additional info section",
        label: "traveler-info-add-info-close-click",
    },
    booking_select_traveler_information_additional_info_frequent_flyer_program_name: {
        category: "Traveler Information",
        action: "User enters frequent flyer program name",
        label: "booking-traveler-additional-info-ffp",
    },
    booking_select_traveler_information_additional_info_frequent_flyer_number: {
        category: "Traveler Information",
        action: "User enters frequent flyer number",
        label: "booking-traveler-additional-info-ffp",
    },
    booking_select_traveler_information_additional_info_tsa_precheck_pass_id: {
        category: "Traveler Information",
        action: "User enters TSA PreCheck ID",
        label: "traveler-info-add-info-tsa-id-click",
    },
    booking_select_traveler_information_additional_info_tsa_precheck_redress_number: {
        category: "Traveler Information",
        action: "User enters TSA Redress number",
        label: "traveler-info-add-info-tsa-redress-click",
    },
    booking_select_traveler_information_additional_info_meal_preferences_meal_type: {
        category: "Traveler Information",
        action: "User selects meal preference",
        label: "traveler-info-add-info-meal-open-click",
    },
    traveler_info_add_info_meal_close_click: {
        category: "Traveler Information",
        action: "User closes meal preference selection",
        label: "traveler-info-add-info-meal-close-click",
    },
    traveler_info_add_info_meal_option_click: {
        category: "Traveler Information",
        action: "User selects a meal preference option",
        label: "traveler-info-add-info-meal-option-click",
    },
    booking_select_traveler_information_additional_info_special_assistance: {
        category: "Traveler Information",
        action: "User requests special assistance",
        label: "traveler-info-add-info-spcl-open-click",
    },
    traveler_info_add_info_spcl_close_click: {
        category: "Traveler Information",
        action: "User requests special assistance close",
        label: "traveler-info-add-info-spcl-close-click",
    },
    traveler_info_add_info_spcl_option_click: {
        category: "Traveler Information",
        action: "User requests special assistance selecting option",
        label: "traveler-info-add-info-spcl-option-click",
    },
    booking_select_traveler_open_recent_traveler_list: {
        category: "Traveler Selection",
        action: "User opens recent traveler list",
        label: "traveler-info-recent-list-open-click",
    },
    traveler_info_recent_list_option_click: {
        category: "Traveler Information",
        action: "User selects a traveler from recent list",
        label: "traveler-info-select-traveler-click",
    },
    traveler_info_recent_list_close_click: {
        category: "Traveler Information",
        action: "User closes recent traveler list",
        label: "traveler-info-recent-list-close-click",
    },

    booking_select_traveler_add_new_traveler: {
        category: "Traveler Selection",
        action: "User adds a new traveler",
        label: "traveler-info-new-traveler-click",
    },
    booking_select_traveler_edit_traveller: {
        category: "Traveler Selection",
        action: "User edits a traveler",
        label: "traveler-info-edit-traveler-click",
    },
    booking_select_traveler_edit_traveler_save: {
        category: "Traveler Selection",
        action: "User saves edited traveler",
        label: "traveler-info-edit-traveler-save-click",
    },
    booking_select_traveler_edit_traveler_cancel: {
        category: "Traveler Selection",
        action: "User cancels editing traveler",
        label: "traveler-info-edit-traveler-cancel-click",
    },
    booking_select_traveler_select_a_traveler_from_recent_traveler: {
        category: "Traveler Selection",
        action: "User selects a traveler from recent list",
        label: "traveler-info-select-traveler-click",
    },

    booking_room_assignment_open_recent_traveler_list: {
        category: "Room Assignment",
        action: "User opens recent traveler list in room assignment",
        label: "traveler-info-room-traveler-open-click",
    },
    booking_room_assignment_close_recent_traveler_list: {
        category: "Room Assignment",
        action: "User close recent traveler list in room assignment",
        label: "traveler-info-room-traveler-close-click",
    },
    booking_room_assignment_add_new_traveller: {
        category: "Room Assignment",
        action: "User adds a new traveler in room assignment",
        label: "traveler-info-room-add-traveler-click",
    },
    booking_room_assignment_select_a_traveler_from_recent_traveller: {
        category: "Room Assignment",
        action: "User selects a traveler from recent list in room assignment",
        label: "traveler-info-room-traveler-option-click",
    },
    booking_save_collected_missing_info: {
        category: "Booking collected info",
        action: "User saves collected missing information",
        label: "traveler-info-room-miss-info-save-click",
    },
    booking_close_collected_missing_info: {
        category: "Booking collected info",
        action: "User closes collected missing information",
        label: "traveler-info-room-miss-info-close-click",
    },


}